export default {
    InternalOrderListcompent: {
        Third: '客户订单号',
        Internal: '内部订单号',
        type: '订单类型',
        status: '订单状态',
        store: '销售店铺',
        channel: '销售渠道',
        Payment: '支付状态',
        line: '商品行数量',
        amount: '商品总金额',
        Buyer: '买家应付',
        Total: '商品总成本',
        actual: '买家实付',
        Shipment: '发货状态',
        Receiving: '收货状态',
        nickname: '买家昵称',
        name: '收货人姓名',
        phone: '收货人手机号',
        address: '收货人地址',
        party: '三方下单时间',
        time: '支付时间',
        order: 'ERP创单时间',
        customerTIP: '请先选择客户'
    },
};
